const Bugatti = [
    {
        ID: "bugatti_1",
        name: "Veyron",
        brand: "Bugatti",
        price: 32,
        engine: "W16 8.0L",
        max: 415,
        version: "7 AT",
        type: "Coupe",
        avatar: "https://i.ibb.co/HX8mGLF/veyron.webp",
        link: "/brands/bugatti/veyron",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "bugatti_2",
        name: "Chiron Super Sport",
        brand: "Bugatti",
        price: 90,
        engine: "W16 8.0 L",
        max: 440,
        version: "7 AT",
        type: "Coupe",
        avatar: "https://i.ibb.co/GFh2639/Chiron.webp",
        link: "/brands/bugatti/chiron",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "bugatti_3",
        name: "La Voiture Noire",
        brand: "Bugatti",
        price: 444,
        engine: "W16 8.0 L",
        max: 418,
        version: "7 AT",
        type: "Coupe",
        avatar: "https://i.ibb.co/6Dd5Zwz/La-Voiture-Noire.webp",
        link: "/brands/bugatti/la-voiture-noire",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "bugatti_4",
        name: "Centodieci",
        brand: "Bugatti",
        price: 205,
        engine: "W16 8.0 L",
        max: 380,
        version: "7 DCT",
        type: "Coupe",
        avatar: "https://i.ibb.co/fdQRvgY/centodieci.webp",
        link: "/brands/bugatti/centodieci",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
    {
        ID: "bugatti_5",
        name: "Divo",
        brand: "Bugatti",
        price: 117,
        engine: "W16 8.0 L",
        max: 380,
        version: "DSG 7",
        type: "Coupe",
        avatar: "https://i.ibb.co/MSvQ1y2/divo.webp",
        link: "/brands/bugatti/divo",
        para: {
            priceus: "229,495",
            pricevn: "13,700,000,000",
            max100: 3.6,
            max200: 12.8,
            watt: "650 Hp / 6000",
            momem: "850 Nm / 2500",
            size: "5.112 x 2.016 x 1.638",
            sit: 5,
            long: 3003,
            mam: "21-23",
            hopso: "Tự động 8 cấp",
            dandong: "4 Cầu - AWD",
            tilenen: "-",
            treo: "Khí nén",
            phanh: "Gốm Carbon CCB tiêu chuẩn",
        },
    },
];
export default Bugatti;
